import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchQuote } from './quoteAPI';
import {DEV,domain, quoterurl, CRMURL} from '../../app/settings'
import _ from 'lodash'
import $ from 'jquery';

const initialState = {
    status: 'idle',
    result: ''
};


export const getQuote = createAsyncThunk(
    'quote/getQuote',
    async (u=null,thunkAPI) => {
        
        const response = await fetchQuote(thunkAPI.getState().fields);
    
        var quotes = [];
        var RWSRes = createQuote(response.RWSv3);
        var RBRes = createQuote(response.RBv3);
        var quotes = {quotes:quotes.concat(RWSRes,RBRes)};
        

        if(!DEV)
            recordPricesIntoCRM(quotes,thunkAPI.getState().fields.user.crmi.value)    

        return quotes;
    }
);

function recordPricesIntoCRM(quotes,id){

    var orderedQuotes = _.orderBy(quotes.quotes,["finalPremium"],["asc"]);
    
    if(orderedQuotes.length > 3)
        orderedQuotes = orderedQuotes.slice(0,3);

    var data = "{";
    for(var i = 0; i < orderedQuotes.length; i++){
        data += '"price__'+(i+1)+'":"'+orderedQuotes[i].finalPremium+'"';
        if(i !== orderedQuotes.length-1)
            data += ',';
    }
    data += "}";

    var formdata = new FormData();
    formdata.append("id", id);
    formdata.append("props", data);

    var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
    };


    fetch(`${domain+quoterurl+CRMURL}`,requestOptions)
            .then((response) => response.text())
            .then((res)=>{});

}

function createQuote(result){
    return _.chain($(result).find('Carriers').children()).filter((el)=>{
        return true;
//         return ($(el).find('Message').map(function(i,el) {
//             switch ($(el).find('MessageID').text()) {
//               case '1': 
//  //             case '143': 
//                 return false;
//             }
//         })).length === 0;

    }).map((elem,i)=>{
        let discounts =_.chain($(elem).find('Discount')).filter((o,i)=>{return parseInt($(o).find('Percentage').text()) > 0;}).map((discount,di) => {return {percent:parseInt($(discount).find('Percentage').text()),text:$(discount).find('Percentage').text()+'% '+$(discount).find('Descript').text()}}).value();
        return {
            tagName:$(elem).prop("tagName"),
            finalPremium:parseInt($(elem).find('PolicyTotal').find('FinalPremium').text()),
            discounts:discounts
        };
    }).filter((elem)=>{
        return (elem.finalPremium > 0)}).value();
}


export const quoteSlice = createSlice({
    name: 'quote',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        
    },
    extraReducers: (builder) => {
        builder
          .addCase(getQuote.pending, (state) => {
            state.status = 'loading';
          })
          .addCase(getQuote.fulfilled, (state, action) => {
            state.status = 'idle';
            state.result = action.payload.quotes
   //         console.log(action.payload.quotes);
            //state.value += action.payload;
          });
    },
});

export const { setQuoteIfcan } = quoteSlice.actions;

export const quoteIfCan = () => (dispatch, getState) => {
    var fields = getState().fields;

    var requiredFields = [
        fields.user.post.value,
        fields.user.trms.value,
        fields.vhcls.values[0].year.value,
        fields.vhcls.values[0].manu.value,
        fields.vhcls.values[0].mkmd.value,
    ];
    
    // console.log(requiredFields.every(isValidField))
    // if(requiredFields.every(isValidField)){
    //     dispatch(getQuote());
    // }
    //dispatch()
    // const currentValue = selectCount(getState());
    // if (currentValue % 2 === 1) {
    //   dispatch(incrementByAmount(amount));
    // }
};

function isValidField(data){
    //console.log(data);
    return typeof data !== "undefined" && data !== false && data.length > 0
}
export default quoteSlice.reducer;